angular.module('leanlaw').controller('MatterTagBillablesDetailCtrl', ['$scope', '$rootScope', '$q', '$filter', '$timeout', '$stateParams', '$state', "alerts", 'userService', 'reportsService', 'commonFilterService', "exportJson", "singleRequest", "objectNumberManipulator", "messageBus", 'matterTagsService', function ($scope, $rootScope, $q, $filter, $timeout, $stateParams, $state, alerts, userService, reportsService, commonFilterService, exportJson, singleRequest, objectNumberManipulator, messageBus, matterTagsService) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    const matter = $scope.me.terms.Matter;
    const exp = $scope.data.filteredClients.reduce((accum, c) => {
      let clientEntry = {
        "Client": c.client.label || c.client.name,
        [matter]: "",
        "Non-billable Hours": $filter("hoursDecimal")(c.data.hours.nonBillable),
        "Billable Hours": $filter("hoursDecimal")(c.data.hours.billable),
        "Hours Amount": $filter("amount")(c.data.amounts.hours)
      };

      // Conditionally add "Fixed Fee Hours" if the feature is enabled
      clientEntry["Fixed Fee Hours"] = $filter("hoursDecimal")(c.data.hours.charges);
      clientEntry = {
        ...clientEntry,
        "Fixed Fees": $filter("amount")(c.data.amounts.charges),
        "Expenses": $filter("amount")(c.data.amounts.expenses),
        "Total Amount": $filter("amount")(c.data.amounts.total)
      };
      accum.push(clientEntry);
      if ($scope && $scope.filter && $scope.filter.include && $scope.filter.include.matters && c.matters) {
        c.matters.forEach(m => {
          let matterEntry = {
            "Client": "",
            [matter]: m.matter.label || m.matter.name,
            "Billable hours": $filter("hoursDecimal")(m.data.hours.billable),
            "Non-billable hours": $filter("hoursDecimal")(m.data.hours.nonBillable),
            "Total hours": $filter("hoursDecimal")(m.data.hours.total),
            "Fixed fees": $filter("amount")(m.data.amounts.charges),
            "Expenses": $filter("amount")(m.data.amounts.expenses),
            "Total amount": $filter("amount")(m.data.amounts.total)
          };

          // Conditionally add "Fixed Fee Hours" for each matter if the feature is enabled
          matterEntry["Fixed Fee Hours"] = $filter("amount")(m.data.hours.charges);
          accum.push(matterEntry);
        });
      }
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  $scope.loading = true;
  userService.me().then(me => {
    $scope.trust = me.company.settings.trustEnabled;
    matterTagsService.getMatterTags().then(mattertags => {
      $scope.matterTag = mattertags.find(t => t.id === $stateParams.matterTag);
      $scope.$on('commonFilterService-statechanged', (event, payload) => {
        if (!payload) return;
        // Assigning to existing filter keeps custom filter options
        $scope.filter = Object.assign($scope.filter, payload);
        // Necessary to set this value for the requests
        $scope.filter.status = $scope.filter.archived.status;
        $scope.filter.scope = $scope.filter.filter.scope;
        $scope.filter.billedState = $scope.filter.billedFilter && $scope.filter.billedFilter.id;

        // if (payload.filter.range) filterClientEntries();
        filterClientEntries();
      });
      $scope.$on("report-sidebar-filterchange", (event, payload) => {
        $scope.filter = Object.assign($scope.filter, payload);
      });
      $scope.$watch('filter.include.accounting', show => {
        if (show) {
          filterClientEntries();
        }
      }, true);

      // MessageBus is used here so that the commonFilter module can pick it up once it loads
      messageBus.addMessage("filterDependency-ready", true);
    });
  });
  function filterClientEntries() {
    $scope.loading = true;
    var query = angular.copy($scope.filter);
    query.matterTag = $scope.matterTag || {
      id: 'none'
    };
    query.data = "services,expenses,charges,hours";
    query.reportType = 'billable';
    singleRequest.serviceCall("clientEntries", reportsService.getClientReport)(query).then(data => {
      if (!data) return;
      $scope.data = data;
      $scope.loading = false;
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("clientEntries");
    deactivate();
  });

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filteredClients = $filter('orderBy')($filter('filter')($scope.data.clients, $scope.search), $scope.sort, $scope.reverse) || [];
    $scope.data.filteredClients.forEach(client => {
      client.filteredMatters = $filter('orderBy')($filter('filter')(client.matters, $scope.q), $scope.sort, $scope.reverse) || [];
    });
  }

  // Totals follow the searched set, as they did when this recomputed from the
  // DOM-populated array. Deliberately not on the data/sort watches, so a reload
  // keeps the figures the API returned.
  function updateTotals() {
    if (!$scope.data || !$scope.data.filteredClients) return;
    objectNumberManipulator.resetValues($scope.data.data);
    ($scope.data.filteredClients || []).forEach(row => {
      objectNumberManipulator.sumValues($scope.data.data, row.data);
    });
  }
  $scope.$watch('data.clients', updateFiltered);
  $scope.$watch('search', () => {
    updateFiltered();
    updateTotals();
  });
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);